import { useQuery } from '@tanstack/react-query';

import { caseReportQueueService } from '../services';

export const reviewQueueKeys = {
  all: ['case-reports', 'review-queue'] as const,
  scoped: (organizationId?: string, locationId?: string) =>
    [
      'case-reports',
      'review-queue',
      { organizationId: organizationId ?? null, locationId: locationId ?? null },
    ] as const,
};

interface UseReviewQueueParams {
  organizationId?: string;
  locationId?: string;
}

/**
 * Reports awaiting the current user's review. Refetches on window focus
 * (default RQ behaviour) so navigating back to the page picks up
 * approve/reject mutations performed elsewhere; the spec also calls for
 * staleTime=0 here since the queue is intentionally a "live backlog"
 * surface, not a cached list. Optional params come from the global
 * tenant scope picker in the topbar.
 */
export function useReviewQueue(params: UseReviewQueueParams = {}) {
  return useQuery({
    queryKey: reviewQueueKeys.scoped(params.organizationId, params.locationId),
    queryFn: () => caseReportQueueService.listReviewQueue(params),
    staleTime: 0,
  });
}
